import { moneyFormatter } from 'lib/helpers'
import { JSX } from 'react'
import { PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts'
export const RadialWithDelta = ({ percent = 0, averageValue = 0, strokeWidth = 12 }: { percent?: number, averageValue?: number, strokeWidth?: number }): JSX.Element => {
  const perfect = percent / 100
  const data = [{ percent: Math.max(0, Math.min(1, perfect)) }]
  const label = moneyFormatter(averageValue)
  const innerRadius = `${100 - strokeWidth * 2}%`
  const outerRadius = `${100 - strokeWidth}%`

  return (
    <div className='relative w-full h-full [&_.recharts-radial-bar-sector:not(.recharts-radial-bar-background-sector)]:hover:opacity-50 [&_.recharts-radial-bar-sector:not(.recharts-radial-bar-background-sector)]:transition-opacity [&_.recharts-radial-bar-sector:not(.recharts-radial-bar-background-sector)]:duration-200 [&_.recharts-radial-bar-sector]:cursor-pointer [&_.recharts-radial-bar-background-sector]:cursor-pointer'>
      <ResponsiveContainer
        className='
    [--delta:var(--color-lm-bg-accent)]
    dark:[--delta:var(--color-dm-bg-accent)] cursor-pointer
  ' width='100%' height='100%'
      >
        <RadialBarChart
          data={data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={90}
          endAngle={-270}
        >
          <defs>
            <linearGradient id='radialBarGradient' x1='0' y1='0' x2='1' y2='1'>
              <stop offset='0%' stopColor='#FFE082' />
              <stop offset='100%' stopColor='var(--color-brand)' />
            </linearGradient>
          </defs>
          <PolarAngleAxis type='number' domain={[0, 1]} tick={false} />
          <RadialBar
            dataKey='percent'
            cornerRadius={10}
            background={{ fill: 'var(--delta)' }}
            fill='url(#radialBarGradient)'
          />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className='pointer-events-none absolute inset-0 flex flex-col items-center justify-center'>
        <div className='text-xl font-medium'>{label}</div>
        <div className='text-sm text-lm-text-secondary dark:text-dm-text-secondary font-medium'>Average order value</div>

      </div>
    </div>
  )
}
